//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { imageLoad } from "../../utils/media";

export default {
  name: "TagItemComponent",
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "people",
    },
  },
  model: {
    prop: "model",
    event: "updateModel",
  },
  watch: {
    position(val) {
      this.$emit("updateModel", val);
    },
  },
  computed: {
    product() {
      return this.type === "product";
    },
    people() {
      return this.type === "people";
    },
    /**
     * 计算tag 容器所在位置
     */
    tagPosition() {
      if (this.tagEl && this.mounted) {
        // 整个气泡宽 高
        const bubbleWidth = this.tagEl.clientWidth;
        const bubbleHeight = this.tagEl.clientHeight + this.arrowSize;
        const groupWidth = this.$parent.$refs.group.clientWidth;
        let left = this.position.x - bubbleWidth / 2 + this.arrowSize;
        let top = this.position.y + this.arrowSize;

        // 计算箭头朝下情况
        if (!this.tagArrowTop) {
          top = this.position.y - bubbleHeight;
        }
        // 左右超出范围
        if (this.overLeftDistance) {
          // 判断已经超出
          if (this.overLeftDistance.isLeft) {
            left = 0;
          } else {
            left = groupWidth - bubbleWidth;
          }
        } else {
          // 正常情况
          left = this.position.x - bubbleWidth / 2;
        }
        return {
          left: `${left}px`,
          top: `${top}px`,
        };
      }
    },
    /**
     * 计算箭头偏移
     */
    arrowPosition() {
      if (this.count) {
      }
      if (this.overLeftDistance === undefined) {
        return {};
      }
      return {
        left: `${this.overLeftDistance.x}px`,
      };
    },
    /**
     * 判断是否超出需要箭头移动
     */
    overLeftDistance() {
      if (this.count) {
      }
      if (this.tagEl && this.mounted) {
        const bubbleWidth = this.tagEl.clientWidth;
        const groupWidth = this.$parent.$refs.group.clientWidth;
        // 此时气泡已经超出左侧极限只能滚动箭头
        if (this.position.x < bubbleWidth / 2) {
          return { x: this.position.x - this.arrowSize, isLeft: true };
        } else if (groupWidth - this.position.x < bubbleWidth / 2) {
          // 右侧超出
          return {
            x: this.position.x + bubbleWidth - groupWidth - this.arrowSize,
            isLeft: false,
          };
        }
      }
    },
    /**
     * 计算箭头是否朝上
     */
    tagArrowTop() {
      if (this.count) {
      }
      if (this.tagEl && this.mounted) {
        const bubbleHeight = this.tagEl.clientHeight + this.arrowSize;
        // 获取父容器
        const groupHeight = this.$parent.$refs.group.clientHeight;
        // 判断气泡箭头朝下是否可以指向坐标
        return groupHeight - this.MAX_TOP - this.position.y > bubbleHeight;
      }
    },
  },
  data() {
    return {
      position: {
        x: 0,
        y: 0,
        position: [0, 0],
        user_id: "",
        username: "",
      },
      count: false,
      tagEl: null,
      MAX_LEFT: 10,
      MAX_TOP: 10,
      arrowSize: 4,
      mounted: false,
    };
  },
  methods: {
    /**
     * 删除按钮点击回调
     */
    remove() {
      this.$emit("remove");
    },
  },
  mounted() {
    this.mounted = false;
    this.$nextTick(async () => {
      this.mounted = true;
      const { clientWidth, clientHeight } = this.$parent.$refs.group;
      this.position = this.model;
      // 初始化位置信息
      this.position.x = clientWidth * this.model.position[0];
      this.position.y = clientHeight * this.model.position[1];
      this.tagEl = this.$refs.tag;
      if (this.readonly) {
        const url = this.$parent.image.cover_url;
        // 获取图片宽高比
        const image = new Image();
        image.src = url;
        await imageLoad({ image });
        const { width, height } = image;
        console.log("width, height", width, height);
        this.position.y =
          (height / width) * clientWidth * this.model.position[1];
      }
      this.count = !this.count;
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/tag/TagItem.vue